import api from 'src/store/api'
import dates from 'src/utils/dates'
import http from 'src/store/http'

import { firecollection } from 'src/store/firebase'

import actionNames from './actionNames'
import User from './utils/user'
import PATHS from '@/router/paths'

const actionMap = {
  organization: {
    CREATE: 'createOrganization',
    READ: 'auth/getOrgData',
    UPDATE: 'updateOrganization',
    DELETE: 'deleteOrganization',
  },
  person: {
    CREATE: 'commitPersonCreate',
    READ: '',
    UPDATE: 'commitPersonUpdate',
    DELETE: 'commitPersonDelete',
  },
  personApi: {
    CREATE: 'createPerson',
    READ: '',
    UPDATE: 'updatePerson',
    DELETE: 'deletePerson',
  },
  project: {
    CREATE: 'createProject',
    READ: '',
    UPDATE: 'updateProject',
    DELETE: 'deleteProject',
  },
  [PATHS.INTERNAL.TIME_ROLLUP]: {
    READ: '',
  },
  [PATHS.INTERNAL.TIME_SHEET]: {
    READ: '',
  },
}

const actions = {
  setup() {},

  async getData({ commit, dispatch }, { params, query, selectedSearch }) {
    if (params.baseReportName === PATHS.INTERNAL.TIME_SHEET) {
      const timeShift = await dispatch('getTimeShiftFromRoute', query)

      commit('timeShift', timeShift)
    }

    if (selectedSearch) {
      query.personId = selectedSearch.personId
    }

    const updateView = () => {
      const { baseReportName, routeName } = params
      const endpointKey = baseReportName || routeName
      return dispatch('tools/updateView', { endpointKey }, { root: true })
    }
    const setView = () => {
      const { reportPath } = query
      const haveSelectedSearch = !!(reportPath && selectedSearch)
      return haveSelectedSearch && dispatch('tools/setView', { params, query }, { root: true })
    }

    return setView() || updateView()
  },

  getTimeShiftFromRoute(context, query) {
    const associationIdMap = {
      'this-week': () => 0,
      'last-week': () => -1,
      'next-week': () => 1,

      'relative-week': (shift) => parseInt(shift, 10),
    }
    const { reportPath, timeShift = 0 } = query

    return associationIdMap[reportPath] ? associationIdMap[reportPath](timeShift) : associationIdMap['this-week']()
  },
  getReportPathForTimeSheets({ rootState }, timeShift) {
    const { reportPath } = rootState.tools
    const timeShiftMap = {
      0: () => 'this-week',
      '-1': () => 'last-week',
      1: () => 'next-week',
    }

    const getCustomReportPath = timeShiftMap[timeShift] && timeShiftMap[timeShift]()
    const getAllowedReportPath = () => ['this-week', 'last-week', 'next-week'].indexOf(reportPath) !== -1 && reportPath

    return getCustomReportPath || getAllowedReportPath() || 'relative-week'
  },
  async setTimeShiftAsRouteParams({ dispatch }, timeShift) {
    const reportPath = await dispatch('getReportPathForTimeSheets', timeShift)
    const searchOption = {
      associationId: 'all-associations',
      baseReportName: PATHS.INTERNAL.TIME_SHEET,
      reportPath,
      routeName: PATHS.INTERNAL.BASE,
      subId: 'all-secondary',
    }

    if (reportPath === 'relative-week') {
      searchOption.timeShift = timeShift
    }

    return dispatch('tools/updateRoute', searchOption, { root: true })
  },

  async timeShiftLeft({ commit, dispatch, state }) {
    const { timeShift } = state
    const newTimeShift = timeShift - 1

    commit('timeShift', newTimeShift)

    return dispatch('setTimeShiftAsRouteParams', newTimeShift)
  },
  async timeShiftRight({ commit, dispatch, state }) {
    const { timeShift } = state
    const newTimeShift = timeShift + 1

    commit('timeShift', newTimeShift)

    return dispatch('setTimeShiftAsRouteParams', newTimeShift)
  },

  mapProject(context, project) {
    const { projectCode, projectId, projectName } = project

    return {
      project_code: projectCode,
      project_id: projectId,
      project_name: projectName,
    }
  },
  async onEditProject({ commit, dispatch }, row) {
    const project = await dispatch('mapProject', row)

    commit('selected', project)
    commit('entry', project)

    commit('action', 'update')

    commit('isProjectModalVisible', true)
  },
  async onDeleteProject({ commit, dispatch }, row) {
    const project = await dispatch('mapProject', row)

    commit('selected', project)
    commit('entry', project)

    commit('action', 'delete')

    commit('isProjectModalVisible', true)
  },

  async updateTimeEntries({ commit, dispatch, rootState }, endpointKey) {
    const { associationId, baseReportName, reportPath, routeName, subId, timeShift } = rootState.tools
    const params = { baseReportName, routeName }
    const query = { associationId, reportPath, subId }
    const { user } = rootState.auth

    if (timeShift) {
      query.timeShift = timeShift
    }

    const responses = await dispatch('tools/request', { endpointKey, params, query, user }, { root: true })
    const [,,,, timeResponse] = responses
    const { content, error } = timeResponse
    const isValidResponse = () => Array.isArray(content)
    const showError = () => {
      const message = 'Error hydrating view. Reload recommended.'

      commit('tools/snackbar', true, { root: true })
      commit('tools/snack', { message, status: 'error' }, { root: true })

      return content
    }
    const success = async () => {
      const data = responses
      const items = await dispatch('transform', { endpointKey, data, query })
      return dispatch('tools/render', { endpointKey, items, params, query }, { root: true })
    }

    return error || !isValidResponse() ? showError() : success()
  },

  async getProject({ rootGetters }, associationId) {
    const isAssociationIdBillingCode = rootGetters['tools/isAssociationIdBillingCode']
    return isAssociationIdBillingCode
      ? api.getProjectByCode(associationId)
      : api.getProjectById(associationId)
  },

  async openTimeEntryFormCreate({ commit, state, rootGetters, rootState }, weekdate) {
    const { defaultEntry } = state
    const persons = rootGetters['tools/persons']
    const { auth: { user } } = rootState

    const defaults = Object.create(defaultEntry)
    const thisPerson = persons.find((person) => person.personEmail === user.email)
    const time_entry_date = dates.getFormattedDate(weekdate, 'YYYY-MM-DD')

    const entry = {
      ...defaults,
      person_id: thisPerson.personId,
      time_entry_date,
      time_classification_id: 'NON-BILLABLE',
    }

    commit('action', 'create')
    commit('weekdate', weekdate)

    commit('selected', entry)
    commit('entry', entry)

    commit('isTimeModalVisible', true)
  },
  openTimeEntryFormUpdate({ commit }, entry) {
    commit('action', 'update')

    commit('selected', entry)
    commit('entry', entry)

    commit('isTimeModalVisible', true)
  },
  openTimeEntryFormDelete({ commit }, entry) {
    commit('action', 'delete')

    commit('selected', entry)
    commit('entry', entry)

    commit('isTimeModalVisible', true)
  },

  createTimeEntry({ commit }, entry) {
    entry.time_entry_date = dates.getFormattedDate(entry.time_entry_date, 'YYYY-MM-DD')

    return api.createTimeEntry(entry).catch((error) => {
      commit(actionNames.ADD_TIME_FAILED, error)
    })
  },
  updateTimeEntry({ commit, rootState }, entry) {
    const { auth } = rootState
    const { user } = auth
    const { email: person_email } = user

    const data = {
      client_id: entry.client_id,
      description: entry.description,
      duration: entry.duration,
      person_email,
      project_id: entry.project_id,
      service_id: entry.service_id,
      time_classification_id: entry.time_classification_id,
      time_entry_date: dates.getFormattedDate(entry.time_entry_date, 'MM-DD-YYYY'),
      time_entry_id: entry.timeEntryId,
    }

    return api.updateTimeEntry(data).catch((error) => {
      commit(actionNames.EDIT_TIME_FAILED, error)
    })
  },
  deleteTimeEntry({ commit, rootState }, entry) {
    const { auth } = rootState
    const { user } = auth
    const { email: person_email } = user
    const { timeEntryId: time_entry_id } = entry

    const data = {
      person_email,
      time_entry_id,
    }

    return api.deleteTimeEntry(data).catch((error) => {
      commit(actionNames.DELETE_TIME_FAILED, error)
    })
  },
  async submitTimeEntry({ dispatch, rootState, state }, entry) {
    const { baseReportName } = rootState.tools
    const { action } = state
    let items

    if (action === 'create') {
      items = await dispatch('createTimeEntry', entry)
    }
    if (action === 'update') {
      items = await dispatch('updateTimeEntry', entry)
    }
    if (action === 'delete') {
      items = await dispatch('deleteTimeEntry', entry)
    }

    dispatch('updateTimeEntries', baseReportName)

    return items
  },

  createItem({ dispatch, rootState }, weekdate) {
    const { tools } = rootState
    const { baseReportName } = tools

    if (baseReportName === 'organization') {
      return dispatch('createOrganizationForm')
    }

    if (baseReportName === 'person') {
      return dispatch('createPersonForm')
    }

    if (baseReportName === 'project') {
      return dispatch('createProjectForm')
    }

    return dispatch('openTimeEntryFormCreate', weekdate)
  },

  showFormOrganization({ commit, dispatch }, { action = 'create', formData }) {
    dispatch('setFormData', { action, formData })
    commit('isOrganizationModalVisible', true)
  },
  showFormOrganizationUpdate({ dispatch }, formData) {
    dispatch('showFormOrganization', { action: 'update', formData })
  },
  showFormOrganizationDelete({ dispatch }, formData) {
    dispatch('showFormOrganization', { action: 'delete', formData })
  },

  mapOrgToClient(context, organization) {
    const {
      action_type,
      billingCode,
      clientId,
      clientName,
      publisherName,
      isAdministrative,
    } = organization

    return {
      action_type,
      billing_code: billingCode,
      client_id: clientId,
      client_name: clientName || publisherName,
      is_administrative: isAdministrative,
    }
  },
  mapEntryToClient(context, organization) {
    const {
      action_type,
      billing_code,
      client_id,
      client_name,
      is_administrative,
    } = organization

    return {
      action_type,
      billing_code,
      client_id,
      client_name,
      is_administrative,
    }
  },
  async createOrganizationForm({ dispatch, state }) {
    const { defaultOrg } = state
    const formData = await dispatch('mapOrgToClient', defaultOrg)

    dispatch('showFormOrganization', { action: 'create', formData })
  },
  async modifyOrganization({ commit, dispatch, rootState }, { events, request }) {
    const { baseReportName } = rootState.tools
    const { succeeded } = events
    const root = { root: true }

    const catcher = (err) => {
      const error = http.catch(err)
      dispatch('messages/showErrorMessage', { error, baseReportName }, root)
      return error
    }
    const response = await api.modifyOrganization(request).catch(catcher)
    const { content, error } = response

    if (error) {
      catcher(error)
    } else {
      const { user } = rootState.auth
      const params = {
        baseReportName: 'organization',
        routeName: 'internal',
      }
      const query = {
        associationId: 'all-associations',
        reportPath: 'all-data',
        subId: 'all-secondary',
      }

      dispatch('auth/getOrganizations', { params, query, user }, { root: true })

      commit(succeeded, content)
    }

    return response
  },
  async createOrganization({ dispatch, rootState }, organization) {
    const { baseReportName } = rootState.tools
    const root = { root: true }
    dispatch('messages/showLoadingMessage', { componentName: baseReportName, text: 'Requesting data ...' }, root)

    const request = await dispatch('mapEntryToClient', organization)

    const failed = actionNames.ADD_ORGANIZATION_FAILED
    const succeeded = actionNames.ADD_ORGANIZATION_SUCCEEDED

    const events = { failed, succeeded }
    const modify = { events, request }

    return dispatch('modifyOrganization', modify)
  },
  async updateOrganization({ commit, dispatch }, organization) {
    commit(actionNames.EDIT_ORGANIZATION_REQUESTED)

    const request = await dispatch('mapEntryToClient', organization)

    const failed = actionNames.EDIT_ORGANIZATION_FAILED
    const succeeded = actionNames.EDIT_ORGANIZATION_SUCCEEDED

    const events = { failed, succeeded }
    const modify = { events, request }

    return dispatch('modifyOrganization', modify)
  },
  async deleteOrganization({ commit, dispatch }, organization) {
    commit(actionNames.DELETE_ORGANIZATION_REQUESTED)

    const { action_type, client_id } = organization
    const request = { action_type, client_id }

    const failed = actionNames.DELETE_ORGANIZATION_FAILED
    const succeeded = actionNames.DELETE_ORGANIZATION_SUCCEEDED

    const events = { failed, succeeded }
    const modify = { events, request }

    return dispatch('modifyOrganization', modify)
  },

  setFormData({ commit }, { action, formData }) {
    commit('selected', { ...formData })
    commit('entry', formData)
    commit('action', action)
  },

  showFormPerson({ commit, dispatch }, { action = 'create', formData }) {
    dispatch('setFormData', { action, formData })
    commit('isPersonModalVisible', true)
  },
  showFormPersonUpdate({ dispatch }, formData) {
    dispatch('showFormPerson', { action: 'update', formData })
  },
  showFormPersonDelete({ dispatch }, formData) {
    dispatch('showFormPerson', { action: 'delete', formData })
  },

  mapPerson(context, personUser) {
    const {
      action_type,
      access = {},
      managerPersonId,
      email: email_person = '',
      personId: person_id,
      personNameFirst: person_name_first = '',
      personNameLast: person_name_last = '',
    } = personUser
    const { active = false, level, role } = access
    const is_admin = level === 'admin'
    const is_internal = role === 'internal'
    const manager_person_id = (is_internal && managerPersonId) || undefined
    const apiActionTypes = {
      CREATE: 'ADD',
      UPDATE: 'UPDATE',
      DELETE: 'DELETE',
    }

    const user = {
      action_type: apiActionTypes[action_type],
      email_person: email_person.trim(),
      is_active: active,
      is_admin,
      is_internal,
      manager_person_id,
      person_name_first: person_name_first.trim(),
      person_name_last: person_name_last.trim(),
    }

    if (person_id !== email_person) {
      user.person_id = person_id
    }

    return user
  },

  async createPersonForm({ dispatch, rootGetters, state }) {
    const organizations = rootGetters['tools/organizations']
    const { defaultPerson, defaultUser } = state
    const personUser = { ...defaultPerson, ...defaultUser }
    const formData = await User.mapPersonAndUser(personUser, organizations)

    dispatch('showFormPerson', { action: 'create', formData })
  },
  async upsertPersonAndUser({ dispatch, rootGetters }, data) {
    const { action, catcher, person } = data
    const hasRightsToUpdate = rootGetters['auth/isInternalWriter']

    if (!hasRightsToUpdate) {
      const metadata = { email: person.email }
      const error = { code: '403', layer: 'app', message: 'Forbidden', metadata }
      return catcher({ error })
    }

    const setUserForFirebase = dispatch('auth/upsertUser', person, { root: true })

    const updateApiPerson = () => {
      const missingRequirements = !person.person_id && action === 'update'
      const safeAction = missingRequirements ? 'create' : action
      const actionRequest = { action: safeAction, catcher, person }
      const crudAction = action.toUpperCase()
      const actionName = actionMap.personApi[crudAction]

      return dispatch(actionName, actionRequest)
    }
    const setPersonForApi = updateApiPerson()

    const [apiRes] = await Promise.all([setPersonForApi, setUserForFirebase])
    const { content, error } = apiRes || {}

    if (error) catcher(apiRes)

    const [apiPerson] = Array.isArray(content) ? content : [content]
    const user = await firecollection.get('person', person.email)

    return { error, person: apiPerson, user }
  },

  async createPerson({ dispatch }, { catcher, person }) {
    const request = await dispatch('mapPerson', person)

    return api.modifyPerson(request).catch(catcher)
  },
  async updatePerson({ dispatch }, { catcher, person }) {
    const request = await dispatch('mapPerson', person)

    return api.modifyPerson(request).catch(catcher)
  },
  async deletePerson(context, { catcher, person }) {
    const { action_type, personId: person_id } = person

    const request = {
      action_type,
      person_id,
    }

    return api.modifyPerson(request).catch(catcher)
  },

  async commitPersonCreate({ commit, dispatch, rootGetters }, person) {
    commit(actionNames.ADD_PERSON_REQUESTED)

    const catcher = (caughtError) => {
      const error = http.catch(caughtError)
      commit(actionNames.ADD_PERSON_FAILED, error)
      return error
    }
    const action = 'CREATE'
    const request = { action, catcher, person }

    const personUser = await dispatch('upsertPersonAndUser', request)
    const { error: personError, person: apiPerson, user } = personUser

    if (personError) return catcher(personUser)

    const content = apiPerson ? { ...apiPerson, ...user } : user

    commit(actionNames.ADD_PERSON_SUCCEEDED, content)

    const columnsByKey = rootGetters['tools/personColumnsByKey']
    const moduleName = 'person'
    const params = {}

    dispatch('setPersonView', { columnsByKey, moduleName, params })

    return content
  },
  async commitPersonUpdate({ commit, dispatch, rootGetters }, person) {
    commit(actionNames.EDIT_PERSON_REQUESTED)

    const catcher = (err) => {
      const error = http.catch(err)
      commit(actionNames.EDIT_PERSON_FAILED, error)
      return error
    }
    const action = 'UPDATE'
    const request = { action, catcher, person }

    const personUser = await dispatch('upsertPersonAndUser', request)
    const { error, person: apiPerson, user } = personUser

    if (error) return catcher(personUser)

    const content = apiPerson ? { ...apiPerson, ...user } : user
    const columnsByKey = rootGetters['tools/personColumnsByKey']
    const moduleName = 'person'
    const params = {}

    dispatch('setPersonView', { columnsByKey, moduleName, params })

    commit(actionNames.EDIT_PERSON_SUCCEEDED, content)

    return content
  },
  async commitPersonDelete({ commit, dispatch, rootGetters }, person) {
    commit(actionNames.DELETE_PERSON_REQUESTED)

    const catcher = (err) => {
      const error = http.catch(err)
      commit(actionNames.DELETE_PERSON_FAILED, error)
      return error
    }
    const action = 'DELETE'
    const request = { action, catcher, person }

    const personUser = await dispatch('upsertPersonAndUser', request)
    const { error, person: apiPerson, user } = personUser

    if (error) return catcher(personUser)

    const content = { ...apiPerson, ...user }

    const columnsByKey = rootGetters['tools/personColumnsByKey']
    const moduleName = 'person'
    const params = {}

    dispatch('setPersonView', { columnsByKey, moduleName, params })

    commit(actionNames.DELETE_PERSON_SUCCEEDED, content)

    return content
  },

  async updateUser({ dispatch, rootGetters }, data) {
    const { catcher, person } = data
    const hasRightsToUpdate = rootGetters['auth/isInternalAdminUser']

    if (!hasRightsToUpdate) {
      const metadata = { email: person.email }
      const error = { code: '403', layer: 'app', message: 'Forbidden', metadata }
      return catcher({ error })
    }

    await dispatch('auth/upsertUser', person, { root: true })

    return firecollection.get('person', person.email)
  },

  showFormProject({ commit, dispatch }, { action = 'create', formData }) {
    dispatch('setFormData', { action, formData })
    commit('isProjectModalVisible', true)
  },
  showFormProjectUpdate({ dispatch }, formData) {
    dispatch('showFormProject', { action: 'update', formData })
  },
  showFormProjectDelete({ dispatch }, formData) {
    dispatch('showFormProject', { action: 'delete', formData })
  },

  async createProjectForm({ dispatch, state }) {
    const { defaultProject } = state
    const formData = await dispatch('mapProject', defaultProject)

    dispatch('showFormProject', { action: 'create', formData })
  },
  async modifyProject({ commit, dispatch, rootGetters, rootState }, { events, request }) {
    const { failed, succeeded } = events

    const catcher = (err) => {
      const error = http.catch(err)
      commit(failed, error)
      return error
    }
    const response = await api.modifyProject(request).catch(catcher)
    const { content, error } = response

    if (error) {
      catcher(error)
    } else {
      const { baseReportName } = rootState.tools
      const columnsByKey = rootGetters['tools/columnsByKey']

      dispatch('setProjectView', { columnsByKey, params: { baseReportName } })

      commit(succeeded, content)
    }

    return response
  },
  async createProject({ commit, dispatch }, project) {
    commit(actionNames.ADD_PROJECT_REQUESTED)

    const { action_type, project_code, project_name } = project
    const request = { action_type, project_code, project_name }
    const failed = actionNames.ADD_PROJECT_FAILED
    const succeeded = actionNames.ADD_PROJECT_SUCCEEDED
    const events = { failed, succeeded }
    const modify = { events, request }

    return dispatch('modifyProject', modify)
  },
  async updateProject({ commit, dispatch }, project) {
    commit(actionNames.EDIT_PROJECT_REQUESTED)

    const { action_type, project_id, project_code, project_name } = project
    const request = { action_type, project_id, project_code, project_name }
    const failed = actionNames.EDIT_PROJECT_FAILED
    const succeeded = actionNames.EDIT_PROJECT_SUCCEEDED
    const events = { failed, succeeded }
    const modify = { events, request }

    return dispatch('modifyProject', modify)
  },
  async deleteProject({ commit, dispatch }, project) {
    commit(actionNames.DELETE_PROJECT_REQUESTED)

    const { action_type, project_id } = project
    const request = { action_type, project_id }
    const failed = actionNames.DELETE_PROJECT_FAILED
    const succeeded = actionNames.DELETE_PROJECT_SUCCEEDED
    const events = { failed, succeeded }
    const modify = { events, request }

    return dispatch('modifyProject', modify)
  },

  async submitAction({ commit, dispatch }, actionRequest) {
    const { action, endpointName, value } = actionRequest
    const currentAction = actionMap[endpointName][action.toUpperCase()]

    if (!currentAction) {
      commit(actionNames.UNKNOWN_ERROR, 'action')

      return Promise.resolve(actionNames.UNKNOWN_ERROR)
    }

    return dispatch(currentAction, value)
  },
  submitOrgAction({ dispatch, state }, organization) {
    const { action } = state
    const endpointName = 'organization'
    const actionRequest = { action, endpointName, value: organization }

    return dispatch('submitAction', actionRequest)
  },
  async submitPersonAction({ dispatch, state }, value) {
    const { action } = state
    const endpointName = 'person'
    const actionRequest = { action, endpointName, value }

    return dispatch('submitAction', actionRequest)
  },
  submitProjectAction({ dispatch, state }, project) {
    const { action } = state
    const endpointName = 'project'
    const actionRequest = { action, endpointName, value: project }

    return dispatch('submitAction', actionRequest)
  },
}

export default actions
